import { render, staticRenderFns } from "./apply_basic.vue?vue&type=template&id=86f8a70e&scoped=true&"
import script from "./apply_basic.vue?vue&type=script&lang=js&"
export * from "./apply_basic.vue?vue&type=script&lang=js&"
import style0 from "./apply_basic.vue?vue&type=style&index=0&id=86f8a70e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f8a70e",
  null
  
)

export default component.exports